import "./InfoBox.css";
import close from "../images/close.png";
import { Trans, useTranslation } from "react-i18next";

function InfoBox (props) {
    const { t } = useTranslation();
    return (
        <div className="box" style={props.style}>
            <Trans>
            <button onClick={props.hideInfoBox} className="close"><img src={close} width={25} height={25} alt="close" /></button>
            <h4>{t("rules")}:</h4>
            <p><span>{t("rule")} 1:</span> {t("rule1")}</p>
            <p><span>{t("rule")} 2:</span> {t("rule2")}</p>
            <p className="m-0"><span>{t("Color_setup_time")}:</span></p>
            <table>
                <thead>
                    <tr>
                        <th>{t("from_color")}</th>
                        <th>{t("to_color")}</th>
                        <th>{t("duration")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td>
                        <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td>
                        <td>12 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td>
                        <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>
                        <td>4 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>
                        <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td>
                        <td>8 {t("hours")}</td>
                    </tr>
                    <tr>
                        <td>*</td>
                        <td>*</td>
                        <td>0 {t("hours")}</td>
                    </tr>
                </tbody>
            </table>
            <p><span>{t("width_setup")}</span> {t("width_formula2")}</p>
            <p><span>{t("score")}</span> {t("score_formula2")}</p>
            <p>{t("reminder")}</p>
            <p><strong>{t("goal")}</strong></p>
            </Trans>
        </div>
    );
}

export default InfoBox;